<template>
    <div class="home">
        <div class="creppy-white-blass-wait">
            <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">LabyHelp Branding</h5>
            <br class="no-move"/>
        </div>

        <div class="main-title">

            <br class="no-move"/>

            <h1 class="headers-text text-dark"><strong>Unser Logo</strong></h1>

            <br class="no-move"/>

            <b-img src="../assets/Allgemein.png" class="img no-move"></b-img>
            <br/>
            <a href="https://labyhelp.de/img/Allgemein.15c502d8.png" download="Allgemein" class="footnote-text text-white-gray-color">Herunterladen</a>

            <br class="no-move"/>

            <div class="container">

                <h1 class="headers-text text-dark"><strong>Uhrheberrecht</strong></h1>
                <p class="body-title-lighter text-dark"><strong>Das Logo ist für jeden zugänglich und frei zu benutzen.<br/> Wir bitten darum das Logo nicht zu verändern!</strong></p>

            </div>

            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{ today.getFullYear() }}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/support">Support</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/apply">Apply</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/creator">Creator</a>
                        -
                        <a style="color: #6868b3"
                           href="ts3server://labyhelp.de">TeamSpeak</a>
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Branding",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>